export const blogCategories = {
  guide: 3,
  buying: 10,
  investment: 9,
  renting: 8,
  selling: 11
};
